import { ConfigProvider, message } from 'antd';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import moment from 'moment';
import 'moment/locale/es';

import Translations from '../../translations';
import { store } from '../../app/store';
import Routing from '../routing';

import '../../assets/styles/main.css';
import '../../assets/icons/fontawesome/css/all.min.css';

message.config({ maxCount: 2 });

moment.locale('es');

const App = () => {
  const translation = Translations['es'] || Translations['es'];
  return (
    <Provider store={store}>
      <ConfigProvider locale={translation.antd}>
        <IntlProvider
          locale={translation.locale}
          messages={translation.messages}
        >
          <BrowserRouter basename="/spider">
            <Routing />
          </BrowserRouter>
        </IntlProvider>
      </ConfigProvider>
    </Provider>
  );
};

export default App;
